<!-- normal ticket -->
<div *ngIf="!admin" class="bg-gray-200 p-4 relative rounded">
    <div class="flex flex-row justify-between items-start">
        <div class="flex flex-row justify-center items-center">
            <img class="h-3 mr-2" src="/assets/ticket.svg" />
            <div class="font-medium">{{ ticket.name }}</div>
        </div>
        <div class="status" [ngClass]="{ open: ticket.open, closed: !ticket.open }">
            <span class="state-state state-dashboard" *ngIf="ticket.open">Offen</span>
            <span class="state-state state-dashboard" *ngIf="!ticket.open">Erledigt <fa-icon [icon]="check"></fa-icon></span>
        </div>
    </div>
    <div *ngIf="expanded" class="flex flex-col mt-8">
        <div class="mb-4">
        <span
            class="block uppercase tracking-wide text-xs font-medium mb-1 text-gray-700"
        >
            Produktkategorie
        </span>
        <span>{{ ticket.category }}</span>
        </div>
        <div class="mb-4">
        <span
            class="block uppercase tracking-wide text-xs font-medium mb-1 text-gray-700"
        >
            Adresse
        </span>
        <span>{{ ticket.address }}</span>
        </div>
        <div class="mb-4">
        <span
            class="block uppercase tracking-wide text-xs font-medium mb-1 text-gray-700"
        >
            Beschreibung
        </span>
        <span>{{ ticket.description }}</span>
        </div>
        <div>
        <span
            class="block uppercase tracking-wide text-xs font-medium mb-1 text-gray-700"
        >
            Bilder
        </span>
        <div class="grid grid-cols-2 gap-2">
            <img
            *ngFor="let image of ticket.images"
            [src]="image.url"
            class="rounded border-2 border-white"
            />
        </div>
        </div>
    </div>
    <hr class="mt-4 mb-2 border-t border-gray-400" />
    <button
        class="w-full text-center text-gray-700 text-sm pt-2 focus:outline-none focus:text-primary-500"
        (click)="expanded = !expanded"
    >
        <span *ngIf="!expanded"
        >Mehr anzeigen <fa-icon [icon]="angleDown"></fa-icon
        ></span>
        <span *ngIf="expanded"
        >Weniger anzeigen <fa-icon [icon]="angleUp"></fa-icon
        ></span>
    </button>
</div>


<!-- admin ticket -->
<button (click)="ticketService.setActiveTicket(ticket.tid)" *ngIf="admin" class="bg-gray-200 w-full focus:outline-none hover:bg-gray-300 focus:bg-gray-300 transition-all duration-200 ease-in-out">
    <div [ngClass]="{'shadow-primary': ticket.tid === ticketService.activeTicket?.tid }">
        <div class="flex flex-row items-stretch">
            <div class="flex flex-col items-start mr-auto p-4">
                <div class="font-medium">{{ ticket.name }}</div>
                <span class="text-xs text-gray-700">{{ ticket.creator }}</span>
                <!-- state -->
                <div class="status mt-3" [ngClass]="{ open: ticket.open, closed: !ticket.open }">
                    <div class="state-info">
                        Ticket ist
                    </div>
                    <div class="state-state">
                        <span *ngIf="ticket.open">Offen</span>
                        <span *ngIf="!ticket.open">Erledigt <fa-icon [icon]="check"></fa-icon></span>
                    </div>
                </div>
            </div>
            <div class="ticket-realism w-2"></div>
            <div class="flex flex-col items-end justify-between p-4" style="width: 180px;">
                <div class="flex flex-col items-end text-gray-700 text-xs">
                    <div [ngClass]="{ 'text-red-600': timeUnanswered > 7 && ticket.open }">Vor {{ timeUnanswered }} Tagen erstellt<span class="inline-flex justify-center w-5"><fa-icon [icon]="calendar"></fa-icon></span></div>
                    <div>{{ ticket.images.length }}<span class="inline-flex justify-center w-5"><fa-icon [icon]="rectangleLandscape"></fa-icon></span></div>
                </div>
                <!-- close ticket button -->
                <button
                *ngIf="ticket.open"
                class="text-center text-white px-2 py-1 bg-primary-500 text-sm focus:outline-none hover:bg-primary-700 focus:bg-primary-700"
                (click)="ticketService.closeTicket(ticket.tid)"
                >
                    Ticket schließen <fa-icon [icon]="check"></fa-icon>
                </button>
                <!-- reopen ticket button -->
                <button
                    *ngIf="!ticket.open"
                    class="text-center text-white px-2 py-1 bg-primary-500 text-sm focus:outline-none hover:bg-primary-700 focus:bg-primary-700"
                    (click)="ticketService.reopenTicket(ticket.tid)"
                >
                    Erneut öffnen <fa-icon [icon]="ban"></fa-icon>
                </button>
            </div>
        </div>
    </div>
</button>
